import { create } from 'zustand';

type AuthRecoveryStore = {
  authUnavailable: boolean;
  setAuthUnavailable: (value: boolean) => void;
};

export const useAuthRecoveryStore = create<AuthRecoveryStore>((set) => ({
  authUnavailable: false,
  setAuthUnavailable: (authUnavailable) => set({ authUnavailable }),
}));
